import { gql } from '@apollo/client';

export const GET_ORGANISATION_FOR_TYPE = gql`
  query GetOrganisationForType($input: OrganisationAddOnsInput!) {
    organisation: getOrganisationForType(input: $input) {
      id
    }
  }
`;
